/**
 * All of the code for your public-facing JavaScript source
 * should reside in this file.
 *
 * Note: It has been assumed you will write jQuery code here, so the
 * $ function reference has been prepared for usage within the scope
 * of this function.
 *
 * This enables you to define handlers, for when the DOM is ready:
 *
 * $(function() {
 *
 * });
 *
 * When the window is loaded:
 *
 * $( window ).load(function() {
 *
 * });
 *
 * ...and/or other possibilities.
 *
 * Ideally, it is not considered best practise to attach more than a
 * single DOM-ready or window-load handler for a particular page.
 * Although scripts in the WordPress core, Plugins and Themes may be
 * practising this, we should strive to set a better example in our own work.
 */

import jQuery from 'jquery';

//import './anim8';
//import MouseCursor from './mouse.cursor';

//import './carousel.marquee';
import './carousel.gallery';
import './carousel.brands';
import './carousel.reviews';
import './navigation';
//import VideoUi from './video.ui';


const CUSTOM_SCROLLBAR = true;

(function ($) {
	'use strict';

	// HIDE LOGS ON PROD
	/**/
	console.log = function(){};
	console.info = function(){};
	console.warn = function(){};
	console.error = function(){};
	/**/

	// wait until DOM is ready
	document.addEventListener('DOMContentLoaded', (event) => {

		console.info('DOM loaded');

		//wait until images, links, fonts, stylesheets, and js is loaded
		window.addEventListener('load', (e) => {

			const windowOn = $(window);
			let larger = 1600;
			let xxl = 1400;
			let xl = 1200;
			let lg = 992;
			let md = 768;
			let sm = 576;
			let device_width = window.innerWidth;
			const mediaQuery = window.matchMedia('(max-width: 1024px)');

			//const cursor = new MouseCursor('cta');
			//new VideoUi( cursor );

			if (CUSTOM_SCROLLBAR === true) {

				//$('html').addClass('custom-scroll');
				console.info("App.js loaded");

			} else {
				$('html').addClass('no-custom-scroll');
			}

		}, false);

	});

})(jQuery);
